import type { QueryKey } from '@tanstack/react-query';

/** Only the public data required to replace a route's static HTML. */
export function prerenderQueries(pathname: string): QueryKey[] {
  if (pathname.startsWith('/tool/')) return [['tool', decodeURIComponent(pathname.slice(6))]];
  if (pathname.startsWith('/skills/') && pathname !== '/skills/submit') return [['skill-public', decodeURIComponent(pathname.slice(8))]];
  if (pathname === '/skills') return [['skills-public']];
  if (pathname === '/categories') return [['categories']];
  if (pathname.startsWith('/categories/')) return [['categories'], ['tools', { category: decodeURIComponent(pathname.slice(12)) }]];
  if (pathname === '/middle-east') return [['tools', 'middle-east']];
  if (pathname === '/best-free-ai-tools') return [['tools', { pricing: 'free' }], ['tools', { pricing: 'freemium' }]];
  return [];
}